import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Partner Admin (and Superadmin) guard for /partner-admin/*
const ProtectedPartnerAdminRoute = ({ children }) => {
  const { loading, adminRole, user } = useAuth();

  if (loading) return null;

  const isPartnerAdmin = adminRole === 'partner_admin' || adminRole === 'superadmin' || !!user?.is_superadmin;

  if (!isPartnerAdmin) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedPartnerAdminRoute;